var _title, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDownload = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic/Download")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.75,11 C21.472,11 24.5,14.028 24.5,17.75 C24.5,21.472 21.472,24.5 17.75,24.5 C14.028,24.5 11,21.472 11,17.75 C11,14.028 14.028,11 17.75,11 Z M17.75,12.5 C14.855,12.5 12.5,14.855 12.5,17.75 C12.5,20.645 14.855,23 17.75,23 C20.645,23 23,20.645 23,17.75 C23,14.855 20.645,12.5 17.75,12.5 Z M17.249,13.5 C17.663,13.5 18,13.836 18,14.25 L18,18.439 L18.97,17.469 C19.112,17.327 19.3,17.249 19.5,17.249 C19.7,17.249 19.889,17.327 20.03,17.469 C20.322,17.761 20.322,18.237 20.03,18.53 L17.78,20.78 C17.71,20.85 17.628,20.905 17.535,20.943 C17.527,20.946 17.518,20.95 17.509,20.953 C17.428,20.984 17.339,21 17.25,21 C17.163,21 17.076,20.984 16.992,20.954 C16.986,20.952 16.981,20.95 16.975,20.948 C16.871,20.906 16.789,20.851 16.719,20.781 L14.469,18.531 C14.177,18.239 14.177,17.763 14.469,17.47 C14.611,17.328 14.799,17.25 14.999,17.25 C15.199,17.25 15.388,17.328 15.529,17.47 L16.499,18.44 L16.499,14.25 C16.499,13.836 16.835,13.5 17.249,13.5 Z M12.879,0 C13.48,0 14.044,0.234 14.469,0.658 L17.341,3.53 C17.766,3.955 18,4.52 18,5.121 L18,8.25 C18,8.664 17.664,9 17.25,9 C16.836,9 16.5,8.664 16.5,8.25 L16.5,5.121 C16.5,4.924 16.42,4.731 16.281,4.591 L13.409,1.719 C13.267,1.578 13.079,1.5 12.879,1.5 L2.25,1.5 C1.836,1.5 1.5,1.836 1.5,2.25 L1.5,18.75 C1.5,19.164 1.836,19.5 2.25,19.5 L8.25,19.5 C8.664,19.5 9,19.836 9,20.25 C9,20.664 8.664,21 8.25,21 L2.25,21 C1.009,21 0,19.991 0,18.75 L0,2.25 C0,1.009 1.009,0 2.25,0 L12.879,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.-Site-Icons",
    transform: "translate(-255, -753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/Download",
    transform: "translate(255, 753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c/grey/600"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#337AB7",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_get_app_24px"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Download.5354c57c.svg";
export { ForwardRef as ReactComponent };